module.exports = __webpack_public_path__ + "img/id-menu-sel-3.d062aae3.svg";